<template>
  <div>
    <base-dialog
      @save-item="saveItem"
      dialogId="edit-portal-configuration-language-dialog"
      :open.sync="openDialog"
      :form-ref.sync="portalConfigurationFormRef"
      :loading.sync="isLoading"
    >
      <template v-slot:[`dialog.title`]>
        <span>Configuration du portail</span>
      </template>
      <template v-slot:[`dialog.content`]>
        <v-container>
          <div id="portal-form" v-if="(isGroup && !isBuiltIn) || !isGroup">
            <v-row no-gutters>
              <v-col cols="12">
                <div>Langues disponibles</div>
                <v-row no-gutters>
                  <div
                    v-for="(
                      language, index
                    ) in portalConfigurationModel.languages"
                    :key="index"
                  >
                    <v-col cols="12" md="6">
                      <v-checkbox
                        :rules="rules.languagesRules"
                        :key="language"
                        v-model="parentPortalConfiguration.languages"
                        :label="language.toUpperCase()"
                        :value="language"
                      ></v-checkbox>
                    </v-col>
                  </div>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-select
                  label="Langue par défault"
                  v-model="parentPortalConfiguration.default_language"
                  :items="parentPortalConfiguration.languages"
                  :rules="rules.default_languageRules"
                ></v-select>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </template>
      <template v-slot:[`dialog.actions.save`]>Mettre à jour</template>
    </base-dialog>
  </div>
</template>

<script>
import { computed, watch } from "@vue/composition-api";
import { usePortalConfiguration } from "@/composables/portal-configuration";
import BaseDialog from "@/components/General/BaseDialog.vue";

export default {
  components: {
    BaseDialog,
  },
  props: {
    isInherit: Boolean,
    isBuiltIn: Boolean,
    portalOptionsId: Number,
    isGroup: Boolean,
    updatePortalConfiguration: Function,
    id: String,
    portalConfigurationModel: Object,
    group: Object,
    partner: Object,
    portalConfiguration: {
      type: Object,
      required: true,
    },
    open: Boolean,
    rules: Object,
  },
  setup(props, { emit }) {
    /* Import des API */
    const {
      initConfigurationForm,
      portalConfigurationFormRef,
      portalProfile,
    } = usePortalConfiguration();

    const parentPortalConfiguration = initConfigurationForm(props);

    /* Computed */
    const openDialog = computed({
      get: () => props.open,
      set: (value) => {
        emit("update:open", value);
      },
    });

    /* Méthodes */
    const saveItem = async function () {
      await props.updatePortalConfiguration(
        props.id,
        parentPortalConfiguration,
        props.isInherit,
        props.isBuiltIn,
        portalProfile.value,
        portalConfigurationFormRef.value
      );
      openDialog.value = false;
    };

    /* Watchers */
    watch(
      () => parentPortalConfiguration.languages,
      (newValue) => {
        if (
          newValue.length == 0 ||
          (newValue.length > 0 &&
            !newValue.includes(parentPortalConfiguration.default_language))
        ) {
          parentPortalConfiguration.default_language = null;
        }
      }
    );

    return {
      parentPortalConfiguration,
      portalProfile,
      portalConfigurationFormRef,
      openDialog,
      saveItem,
    };
  },
  methods: {},
};
</script>
